import { ElMessageBox, ElNotification } from "element-plus";

type MessageType = "success" | "warning" | "info" | "error";

export const useMessage = () => {
  const notify = (message: string, type: MessageType = "info") => {
    return ElNotification({ message, type });
  };

  const confirm = (message: string, confirmText = "확인", cancelText = "취소") => {
    return ElMessageBox.confirm(message, {
      confirmButtonText: confirmText, cancelButtonText: cancelText,
    }).then(() => {
      return true;
    }).catch(() => {
      return false;
    });
  };

  const alert = (message: string, confirmText = "확인") => {
    return ElMessageBox.alert(message, { confirmButtonText: confirmText });
  };

  return { notify, confirm, alert };
};
